import type { IField } from "../store/models/field";

export function isField(value: any): value is IField {
    return !!(value as IField)?.fieldPath;
}